import { ColumnsForeignAccount } from './Column';
import { DefaultTable } from '../Components/DefaultTable';
import { FormfieldForeign } from './FormfieldForeign';
import FitButtons from '../Components/FitButton';
import { SeeAll } from '../Components/SeeAll';
import { useState } from 'react';
import { useRef } from 'react';
import { Data } from './Data';
import ReactLoading from 'react-loading';

export const TableForeign = (props) => {
  const [showform, setShowForm] = useState(false);
  const { foreignAccountData } = Data();
  const ref = useRef(null);

  // console.log(JSON.stringify(foreignAccountData));
  const handleShowandHideForm = () => {
    setShowForm(!showform);
    ref.current?.element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <div className='flex flex-row justify-between pb-6'>
        <SeeAll name='Foreign Accounts' seeAll={false} />
        <FitButtons
          details='+ Add bank account'
          color='bigblue'
          icon={false}
          onClick={handleShowandHideForm}
        />
      </div>
      <div className='flex flex-col gap-16'>
        {foreignAccountData?.length === 0 ? (
          <ReactLoading type='cylon' color='#5AC8FA' height={44} width={44} />
        ) : (
          <div className='overflow-x-auto'>
            <DefaultTable
              columns={ColumnsForeignAccount}
              data={foreignAccountData}
            />
          </div>
        )}
        {showform && (
          <FormfieldForeign
            onClick={handleShowandHideForm}
            // ref={ref}
            toggleAddAccountForm={handleShowandHideForm}
          />
        )}
      </div>
    </div>
  );
};
